// Dependencies
import { BrowserRouter } from 'react-router-dom';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import i18nextConfig from './config/i18nextConfig';
import 'intro.js/introjs.css';
// Components, config, utils ..
import App from './base/App';
import './resources/font';
import configureStore from './store/configureStore';
import LoadingFallback from './components/common/LoadingFallback';
import Auth0ProviderWithNavigate from './components/auth0/Auth0ProviderWithNavigate';
import AuthInfoManager from './components/auth0/AuthInfoManager';

const store = configureStore();

if (
  !process.env.REACT_APP_DOMAIN
  || !process.env.REACT_APP_CLIENT_ID
  || !process.env.REACT_APP_AUDIENCE
) throw new Error('Auth0 environment variables not defined.');

i18nextConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<LoadingFallback />}>
    <Provider store={store}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Auth0ProviderWithNavigate>
          <AuthInfoManager />
          <App />
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
    </Provider>
  </Suspense>,
);
